/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AbsenceRequestResponse } from '../api-models';
// @ts-ignore
import { AccrualResponse } from '../api-models';
// @ts-ignore
import { AppMenuResponse } from '../api-models';
// @ts-ignore
import { ChangePasswordRequestModel } from '../api-models';
// @ts-ignore
import { EmployeeResponseBase } from '../api-models';
// @ts-ignore
import { EmployeeResponseExtended } from '../api-models';
// @ts-ignore
import { EmployeeScheduleBussinessResponse } from '../api-models';
// @ts-ignore
import { EmployeeShiftSummary } from '../api-models';
// @ts-ignore
import { FindEmployeeRequest } from '../api-models';
// @ts-ignore
import { GetEmployeeOpenShiftResponse } from '../api-models';
// @ts-ignore
import { LockUserAccountRequest } from '../api-models';
// @ts-ignore
import { LogRequest } from '../api-models';
// @ts-ignore
import { LoggOutRequest } from '../api-models';
// @ts-ignore
import { LogsRequest } from '../api-models';
// @ts-ignore
import { MobileAppConfigs } from '../api-models';
// @ts-ignore
import { OkResult } from '../api-models';
// @ts-ignore
import { OpenShiftUpdateResponse } from '../api-models';
// @ts-ignore
import { PayPeriodDayOfWeekResponse } from '../api-models';
// @ts-ignore
import { PayPeriodResponse } from '../api-models';
// @ts-ignore
import { PayTypeBreakUp } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { PunchHistoryAndSummaryResponse } from '../api-models';
// @ts-ignore
import { Response } from '../api-models';
// @ts-ignore
import { TaConfigurationManager } from '../api-models';
// @ts-ignore
import { TimeCardResponse } from '../api-models';
// @ts-ignore
import { ViewShiftTypeDto } from '../api-models';
// @ts-ignore
import { WorkPatternTypeResponse } from '../api-models';
/**
 * EmployeeApi - axios parameter creator
 * @export
 */
export const EmployeeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get employee\'s accruals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeAccrualsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/accruals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Menu Items Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeAppMenuGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/app-menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change Password  To allow users to update their password, we will need to create an endpoint on your server that accepts the user\'s current password and the new password, and then updates the password in your database.
         * @param {ChangePasswordRequestModel} [changePasswordRequestModel] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        employeeChangePasswordPost: async (changePasswordRequestModel?: ChangePasswordRequestModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeConfigurationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDeleteAccountDelete: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/delete-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns scheduler-pro work patterns when the work pattern is enabled for scheduler AND the  facility uses the scheduler website, otherwise the simple-scheduling patterns. SPD-5493: the  caller passes enabledForScheduler reflecting the Work Pattern modal\'s  \'Enabled for Scheduler\' checkbox; when omitted it falls back to the employee\'s saved state.
         * @param {number} employeeId 
         * @param {boolean} [enabledForScheduler] The modal \&#39;Enabled for Scheduler\&#39; state; null &#x3D; use the employee\&#39;s saved state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeEmployeeIdWorkPatternOptionsGet: async (employeeId: number, enabledForScheduler?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('employeeEmployeeIdWorkPatternOptionsGet', 'employeeId', employeeId)
            const localVarPath = `/employee/{employeeId}/work-pattern-options`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (enabledForScheduler !== undefined) {
                localVarQueryParameter['enabledForScheduler'] = enabledForScheduler;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a list of employees, either all or filtered by a search term.
         * @param {string} [searchText] Optional search term to filter employees by full name or employee ID (case-insensitive).  If null or empty, all employees will be retrieved.
         * @param {number} [numberOfEmployeePerPage] Optional page size. If null, retrieves all employees.
         * @param {number} [page] Optional page number. Defaults to 1 if null.
         * @param {number} [employeeStatusTypeId] Status filter; -1 disables status filtering (default -1).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeGet: async (searchText?: string, numberOfEmployeePerPage?: number, page?: number, employeeStatusTypeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (numberOfEmployeePerPage !== undefined) {
                localVarQueryParameter['numberOfEmployeePerPage'] = numberOfEmployeePerPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (employeeStatusTypeId !== undefined) {
                localVarQueryParameter['employeeStatusTypeId'] = employeeStatusTypeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeIdAbsenceRequestsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('employeeIdAbsenceRequestsGet', 'id', id)
            const localVarPath = `/employee/{id}/absence-requests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs from mobile
         * @param {LogRequest} [logRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLogPost: async (logRequest?: LogRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        employeeLogoutGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoggOutRequest} [loggOutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLogoutPost: async (loggOutRequest?: LoggOutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loggOutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs from mobile
         * @param {LogsRequest} [logsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLogsPost: async (logsRequest?: LogsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeOpenshiftGet: async (version?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/openshift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} openShiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeOpenshiftOpenShiftIdInterestedPost: async (openShiftId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openShiftId' is not null or undefined
            assertParamExists('employeeOpenshiftOpenShiftIdInterestedPost', 'openShiftId', openShiftId)
            const localVarPath = `/employee/openshift/{openShiftId}/interested`
                .replace(`{${"openShiftId"}}`, encodeURIComponent(String(openShiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeOpenshiftsInRangeGet: async (startDate?: string, endDate?: string, version?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/openshifts-in-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The returned OpenShifts.BusinessObjects.Response.PayPeriodDayOfWeekResponse contains `DayIndex` (0–6),  where 0 = Sunday and 6 = Saturday.
         * @summary Retrieves the start day of the week for the current employee\'s pay period.
         * @param {number} [facilityId] Optional facility identifier. If provided, ensures validation against multi-facility configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayperiodStartDayofweekGet: async (facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/payperiod-start-dayofweek`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayperiodsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/payperiods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePaytypeStartDateEndDateGet: async (startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('employeePaytypeStartDateEndDateGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('employeePaytypeStartDateEndDateGet', 'endDate', endDate)
            const localVarPath = `/employee/paytype/{StartDate}/{EndDate}`
                .replace(`{${"StartDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"EndDate"}}`, encodeURIComponent(String(endDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permissions api will allow the mobile to directly access database configuration items  and hide and show mobile items based on the configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePermissionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a filtered and paginated list of employees.
         * @param {FindEmployeeRequest} [findEmployeeRequest] Query parameters used for filtering and pagination.    Includes search text, page size, page index, employee status, and pending absence options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePost: async (findEmployeeRequest?: FindEmployeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findEmployeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [payPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePunchHistoryWithSummaryGet: async (payPeriodId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/punch-history-with-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (payPeriodId !== undefined) {
                localVarQueryParameter['payPeriodId'] = payPeriodId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeRemoveShiftPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/remove-shift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        employeeResetPasswordPut: async (lockUserAccountRequest?: LockUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeShiftSummaryGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/shift-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeShifttypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/shifttypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeTimecardGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/timecard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeV2OpenshiftGet: async (version?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/v2/openshift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeV2OpenshiftsInRangeGet: async (startDate?: string, endDate?: string, version?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/v2/openshifts-in-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [payDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeV2WorkSchedulesGet: async (payDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/v2/work-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [payDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeV2WorkSchedulesInRangeGet: async (payDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/v2/work-schedules-in-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [payDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeWorkSchedulesGet: async (payDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/work-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [payDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeWorkSchedulesInRangeGet: async (payDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/work-schedules-in-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeApi - functional programming interface
 * @export
 */
export const EmployeeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get employee\'s accruals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeAccrualsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccrualResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeAccrualsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Menu Items Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeAppMenuGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppMenuResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeAppMenuGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change Password  To allow users to update their password, we will need to create an endpoint on your server that accepts the user\'s current password and the new password, and then updates the password in your database.
         * @param {ChangePasswordRequestModel} [changePasswordRequestModel] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async employeeChangePasswordPost(changePasswordRequestModel?: ChangePasswordRequestModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeChangePasswordPost(changePasswordRequestModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeConfigurationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaConfigurationManager>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeConfigurationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeDeleteAccountDelete(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeDeleteAccountDelete(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns scheduler-pro work patterns when the work pattern is enabled for scheduler AND the  facility uses the scheduler website, otherwise the simple-scheduling patterns. SPD-5493: the  caller passes enabledForScheduler reflecting the Work Pattern modal\'s  \'Enabled for Scheduler\' checkbox; when omitted it falls back to the employee\'s saved state.
         * @param {number} employeeId 
         * @param {boolean} [enabledForScheduler] The modal \&#39;Enabled for Scheduler\&#39; state; null &#x3D; use the employee\&#39;s saved state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeEmployeeIdWorkPatternOptionsGet(employeeId: number, enabledForScheduler?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkPatternTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeEmployeeIdWorkPatternOptionsGet(employeeId, enabledForScheduler, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves a list of employees, either all or filtered by a search term.
         * @param {string} [searchText] Optional search term to filter employees by full name or employee ID (case-insensitive).  If null or empty, all employees will be retrieved.
         * @param {number} [numberOfEmployeePerPage] Optional page size. If null, retrieves all employees.
         * @param {number} [page] Optional page number. Defaults to 1 if null.
         * @param {number} [employeeStatusTypeId] Status filter; -1 disables status filtering (default -1).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeGet(searchText?: string, numberOfEmployeePerPage?: number, page?: number, employeeStatusTypeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeResponseBase>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeGet(searchText, numberOfEmployeePerPage, page, employeeStatusTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeIdAbsenceRequestsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceRequestResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeIdAbsenceRequestsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logs from mobile
         * @param {LogRequest} [logRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeLogPost(logRequest?: LogRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeLogPost(logRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async employeeLogoutGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeLogoutGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoggOutRequest} [loggOutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeLogoutPost(loggOutRequest?: LoggOutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeLogoutPost(loggOutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logs from mobile
         * @param {LogsRequest} [logsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeLogsPost(logsRequest?: LogsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeLogsPost(logsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeOpenshiftGet(version?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmployeeOpenShiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeOpenshiftGet(version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} openShiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeOpenshiftOpenShiftIdInterestedPost(openShiftId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenShiftUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeOpenshiftOpenShiftIdInterestedPost(openShiftId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeOpenshiftsInRangeGet(startDate?: string, endDate?: string, version?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeOpenshiftsInRangeGet(startDate, endDate, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The returned OpenShifts.BusinessObjects.Response.PayPeriodDayOfWeekResponse contains `DayIndex` (0–6),  where 0 = Sunday and 6 = Saturday.
         * @summary Retrieves the start day of the week for the current employee\'s pay period.
         * @param {number} [facilityId] Optional facility identifier. If provided, ensures validation against multi-facility configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePayperiodStartDayofweekGet(facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayPeriodDayOfWeekResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePayperiodStartDayofweekGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePayperiodsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayPeriodResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePayperiodsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePaytypeStartDateEndDateGet(startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayTypeBreakUp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePaytypeStartDateEndDateGet(startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Permissions api will allow the mobile to directly access database configuration items  and hide and show mobile items based on the configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePermissionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppConfigs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePermissionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a filtered and paginated list of employees.
         * @param {FindEmployeeRequest} [findEmployeeRequest] Query parameters used for filtering and pagination.    Includes search text, page size, page index, employee status, and pending absence options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePost(findEmployeeRequest?: FindEmployeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeResponseExtended>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePost(findEmployeeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [payPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePunchHistoryWithSummaryGet(payPeriodId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchHistoryAndSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePunchHistoryWithSummaryGet(payPeriodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeRemoveShiftPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeRemoveShiftPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async employeeResetPasswordPut(lockUserAccountRequest?: LockUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeResetPasswordPut(lockUserAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeShiftSummaryGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeShiftSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeShiftSummaryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeShifttypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewShiftTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeShifttypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeTimecardGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeCardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeTimecardGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeV2OpenshiftGet(version?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmployeeOpenShiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeV2OpenshiftGet(version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeV2OpenshiftsInRangeGet(startDate?: string, endDate?: string, version?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeV2OpenshiftsInRangeGet(startDate, endDate, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [payDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeV2WorkSchedulesGet(payDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeScheduleBussinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeV2WorkSchedulesGet(payDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [payDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeV2WorkSchedulesInRangeGet(payDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeScheduleBussinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeV2WorkSchedulesInRangeGet(payDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [payDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeWorkSchedulesGet(payDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeScheduleBussinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeWorkSchedulesGet(payDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [payDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeWorkSchedulesInRangeGet(payDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeScheduleBussinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeWorkSchedulesInRangeGet(payDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmployeeApi - factory interface
 * @export
 */
export const EmployeeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeApiFp(configuration)
    return {
        /**
         * 
         * @summary Get employee\'s accruals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeAccrualsGet(options?: AxiosRequestConfig): AxiosPromise<AccrualResponse> {
            return localVarFp.employeeAccrualsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Menu Items Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeAppMenuGet(options?: AxiosRequestConfig): AxiosPromise<AppMenuResponse> {
            return localVarFp.employeeAppMenuGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change Password  To allow users to update their password, we will need to create an endpoint on your server that accepts the user\'s current password and the new password, and then updates the password in your database.
         * @param {EmployeeApiEmployeeChangePasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        employeeChangePasswordPost(requestParameters: EmployeeApiEmployeeChangePasswordPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.employeeChangePasswordPost(requestParameters.changePasswordRequestModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeConfigurationGet(options?: AxiosRequestConfig): AxiosPromise<TaConfigurationManager> {
            return localVarFp.employeeConfigurationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDeleteAccountDelete(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeDeleteAccountDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns scheduler-pro work patterns when the work pattern is enabled for scheduler AND the  facility uses the scheduler website, otherwise the simple-scheduling patterns. SPD-5493: the  caller passes enabledForScheduler reflecting the Work Pattern modal\'s  \'Enabled for Scheduler\' checkbox; when omitted it falls back to the employee\'s saved state.
         * @param {EmployeeApiEmployeeEmployeeIdWorkPatternOptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeEmployeeIdWorkPatternOptionsGet(requestParameters: EmployeeApiEmployeeEmployeeIdWorkPatternOptionsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<WorkPatternTypeResponse>> {
            return localVarFp.employeeEmployeeIdWorkPatternOptionsGet(requestParameters.employeeId, requestParameters.enabledForScheduler, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a list of employees, either all or filtered by a search term.
         * @param {EmployeeApiEmployeeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeGet(requestParameters: EmployeeApiEmployeeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeResponseBase>> {
            return localVarFp.employeeGet(requestParameters.searchText, requestParameters.numberOfEmployeePerPage, requestParameters.page, requestParameters.employeeStatusTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeIdAbsenceRequestsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeIdAbsenceRequestsGet(requestParameters: EmployeeApiEmployeeIdAbsenceRequestsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AbsenceRequestResponse>> {
            return localVarFp.employeeIdAbsenceRequestsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs from mobile
         * @param {EmployeeApiEmployeeLogPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLogPost(requestParameters: EmployeeApiEmployeeLogPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeLogPost(requestParameters.logRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        employeeLogoutGet(options?: AxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.employeeLogoutGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeLogoutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLogoutPost(requestParameters: EmployeeApiEmployeeLogoutPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.employeeLogoutPost(requestParameters.loggOutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs from mobile
         * @param {EmployeeApiEmployeeLogsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLogsPost(requestParameters: EmployeeApiEmployeeLogsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeLogsPost(requestParameters.logsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeOpenshiftGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeOpenshiftGet(requestParameters: EmployeeApiEmployeeOpenshiftGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetEmployeeOpenShiftResponse> {
            return localVarFp.employeeOpenshiftGet(requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeOpenshiftOpenShiftIdInterestedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeOpenshiftOpenShiftIdInterestedPost(requestParameters: EmployeeApiEmployeeOpenshiftOpenShiftIdInterestedPostRequest, options?: AxiosRequestConfig): AxiosPromise<OpenShiftUpdateResponse> {
            return localVarFp.employeeOpenshiftOpenShiftIdInterestedPost(requestParameters.openShiftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeOpenshiftsInRangeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeOpenshiftsInRangeGet(requestParameters: EmployeeApiEmployeeOpenshiftsInRangeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeOpenshiftsInRangeGet(requestParameters.startDate, requestParameters.endDate, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * The returned OpenShifts.BusinessObjects.Response.PayPeriodDayOfWeekResponse contains `DayIndex` (0–6),  where 0 = Sunday and 6 = Saturday.
         * @summary Retrieves the start day of the week for the current employee\'s pay period.
         * @param {EmployeeApiEmployeePayperiodStartDayofweekGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayperiodStartDayofweekGet(requestParameters: EmployeeApiEmployeePayperiodStartDayofweekGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PayPeriodDayOfWeekResponse> {
            return localVarFp.employeePayperiodStartDayofweekGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayperiodsGet(options?: AxiosRequestConfig): AxiosPromise<Array<PayPeriodResponse>> {
            return localVarFp.employeePayperiodsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeePaytypeStartDateEndDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePaytypeStartDateEndDateGet(requestParameters: EmployeeApiEmployeePaytypeStartDateEndDateGetRequest, options?: AxiosRequestConfig): AxiosPromise<PayTypeBreakUp> {
            return localVarFp.employeePaytypeStartDateEndDateGet(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permissions api will allow the mobile to directly access database configuration items  and hide and show mobile items based on the configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePermissionsGet(options?: AxiosRequestConfig): AxiosPromise<MobileAppConfigs> {
            return localVarFp.employeePermissionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a filtered and paginated list of employees.
         * @param {EmployeeApiEmployeePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePost(requestParameters: EmployeeApiEmployeePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeResponseExtended>> {
            return localVarFp.employeePost(requestParameters.findEmployeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeePunchHistoryWithSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePunchHistoryWithSummaryGet(requestParameters: EmployeeApiEmployeePunchHistoryWithSummaryGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PunchHistoryAndSummaryResponse> {
            return localVarFp.employeePunchHistoryWithSummaryGet(requestParameters.payPeriodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeRemoveShiftPost(options?: AxiosRequestConfig): AxiosPromise<OkResult> {
            return localVarFp.employeeRemoveShiftPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeResetPasswordPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        employeeResetPasswordPut(requestParameters: EmployeeApiEmployeeResetPasswordPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OkResult> {
            return localVarFp.employeeResetPasswordPut(requestParameters.lockUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeShiftSummaryGet(options?: AxiosRequestConfig): AxiosPromise<EmployeeShiftSummary> {
            return localVarFp.employeeShiftSummaryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeShifttypesGet(options?: AxiosRequestConfig): AxiosPromise<Array<ViewShiftTypeDto>> {
            return localVarFp.employeeShifttypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeTimecardGet(options?: AxiosRequestConfig): AxiosPromise<TimeCardResponse> {
            return localVarFp.employeeTimecardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeV2OpenshiftGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeV2OpenshiftGet(requestParameters: EmployeeApiEmployeeV2OpenshiftGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetEmployeeOpenShiftResponse> {
            return localVarFp.employeeV2OpenshiftGet(requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeV2OpenshiftsInRangeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeV2OpenshiftsInRangeGet(requestParameters: EmployeeApiEmployeeV2OpenshiftsInRangeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeV2OpenshiftsInRangeGet(requestParameters.startDate, requestParameters.endDate, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeV2WorkSchedulesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeV2WorkSchedulesGet(requestParameters: EmployeeApiEmployeeV2WorkSchedulesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeScheduleBussinessResponse> {
            return localVarFp.employeeV2WorkSchedulesGet(requestParameters.payDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeV2WorkSchedulesInRangeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeV2WorkSchedulesInRangeGet(requestParameters: EmployeeApiEmployeeV2WorkSchedulesInRangeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeScheduleBussinessResponse> {
            return localVarFp.employeeV2WorkSchedulesInRangeGet(requestParameters.payDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeWorkSchedulesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeWorkSchedulesGet(requestParameters: EmployeeApiEmployeeWorkSchedulesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeScheduleBussinessResponse> {
            return localVarFp.employeeWorkSchedulesGet(requestParameters.payDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeApiEmployeeWorkSchedulesInRangeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeWorkSchedulesInRangeGet(requestParameters: EmployeeApiEmployeeWorkSchedulesInRangeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeScheduleBussinessResponse> {
            return localVarFp.employeeWorkSchedulesInRangeGet(requestParameters.payDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for employeeChangePasswordPost operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeChangePasswordPostRequest
 */
export interface EmployeeApiEmployeeChangePasswordPostRequest {
    /**
     * 
     * @type {ChangePasswordRequestModel}
     * @memberof EmployeeApiEmployeeChangePasswordPost
     */
    readonly changePasswordRequestModel?: ChangePasswordRequestModel
}

/**
 * Request parameters for employeeEmployeeIdWorkPatternOptionsGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeEmployeeIdWorkPatternOptionsGetRequest
 */
export interface EmployeeApiEmployeeEmployeeIdWorkPatternOptionsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeApiEmployeeEmployeeIdWorkPatternOptionsGet
     */
    readonly employeeId: number

    /**
     * The modal \&#39;Enabled for Scheduler\&#39; state; null &#x3D; use the employee\&#39;s saved state.
     * @type {boolean}
     * @memberof EmployeeApiEmployeeEmployeeIdWorkPatternOptionsGet
     */
    readonly enabledForScheduler?: boolean
}

/**
 * Request parameters for employeeGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeGetRequest
 */
export interface EmployeeApiEmployeeGetRequest {
    /**
     * Optional search term to filter employees by full name or employee ID (case-insensitive).  If null or empty, all employees will be retrieved.
     * @type {string}
     * @memberof EmployeeApiEmployeeGet
     */
    readonly searchText?: string

    /**
     * Optional page size. If null, retrieves all employees.
     * @type {number}
     * @memberof EmployeeApiEmployeeGet
     */
    readonly numberOfEmployeePerPage?: number

    /**
     * Optional page number. Defaults to 1 if null.
     * @type {number}
     * @memberof EmployeeApiEmployeeGet
     */
    readonly page?: number

    /**
     * Status filter; -1 disables status filtering (default -1).
     * @type {number}
     * @memberof EmployeeApiEmployeeGet
     */
    readonly employeeStatusTypeId?: number
}

/**
 * Request parameters for employeeIdAbsenceRequestsGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeIdAbsenceRequestsGetRequest
 */
export interface EmployeeApiEmployeeIdAbsenceRequestsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeApiEmployeeIdAbsenceRequestsGet
     */
    readonly id: number
}

/**
 * Request parameters for employeeLogPost operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeLogPostRequest
 */
export interface EmployeeApiEmployeeLogPostRequest {
    /**
     * 
     * @type {LogRequest}
     * @memberof EmployeeApiEmployeeLogPost
     */
    readonly logRequest?: LogRequest
}

/**
 * Request parameters for employeeLogoutPost operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeLogoutPostRequest
 */
export interface EmployeeApiEmployeeLogoutPostRequest {
    /**
     * 
     * @type {LoggOutRequest}
     * @memberof EmployeeApiEmployeeLogoutPost
     */
    readonly loggOutRequest?: LoggOutRequest
}

/**
 * Request parameters for employeeLogsPost operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeLogsPostRequest
 */
export interface EmployeeApiEmployeeLogsPostRequest {
    /**
     * 
     * @type {LogsRequest}
     * @memberof EmployeeApiEmployeeLogsPost
     */
    readonly logsRequest?: LogsRequest
}

/**
 * Request parameters for employeeOpenshiftGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeOpenshiftGetRequest
 */
export interface EmployeeApiEmployeeOpenshiftGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeOpenshiftGet
     */
    readonly version?: string
}

/**
 * Request parameters for employeeOpenshiftOpenShiftIdInterestedPost operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeOpenshiftOpenShiftIdInterestedPostRequest
 */
export interface EmployeeApiEmployeeOpenshiftOpenShiftIdInterestedPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeOpenshiftOpenShiftIdInterestedPost
     */
    readonly openShiftId: string
}

/**
 * Request parameters for employeeOpenshiftsInRangeGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeOpenshiftsInRangeGetRequest
 */
export interface EmployeeApiEmployeeOpenshiftsInRangeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeOpenshiftsInRangeGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeOpenshiftsInRangeGet
     */
    readonly endDate?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeOpenshiftsInRangeGet
     */
    readonly version?: string
}

/**
 * Request parameters for employeePayperiodStartDayofweekGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeePayperiodStartDayofweekGetRequest
 */
export interface EmployeeApiEmployeePayperiodStartDayofweekGetRequest {
    /**
     * Optional facility identifier. If provided, ensures validation against multi-facility configuration.
     * @type {number}
     * @memberof EmployeeApiEmployeePayperiodStartDayofweekGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for employeePaytypeStartDateEndDateGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeePaytypeStartDateEndDateGetRequest
 */
export interface EmployeeApiEmployeePaytypeStartDateEndDateGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeePaytypeStartDateEndDateGet
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeePaytypeStartDateEndDateGet
     */
    readonly endDate: string
}

/**
 * Request parameters for employeePost operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeePostRequest
 */
export interface EmployeeApiEmployeePostRequest {
    /**
     * Query parameters used for filtering and pagination.    Includes search text, page size, page index, employee status, and pending absence options.
     * @type {FindEmployeeRequest}
     * @memberof EmployeeApiEmployeePost
     */
    readonly findEmployeeRequest?: FindEmployeeRequest
}

/**
 * Request parameters for employeePunchHistoryWithSummaryGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeePunchHistoryWithSummaryGetRequest
 */
export interface EmployeeApiEmployeePunchHistoryWithSummaryGetRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeApiEmployeePunchHistoryWithSummaryGet
     */
    readonly payPeriodId?: number
}

/**
 * Request parameters for employeeResetPasswordPut operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeResetPasswordPutRequest
 */
export interface EmployeeApiEmployeeResetPasswordPutRequest {
    /**
     * 
     * @type {LockUserAccountRequest}
     * @memberof EmployeeApiEmployeeResetPasswordPut
     */
    readonly lockUserAccountRequest?: LockUserAccountRequest
}

/**
 * Request parameters for employeeV2OpenshiftGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeV2OpenshiftGetRequest
 */
export interface EmployeeApiEmployeeV2OpenshiftGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeV2OpenshiftGet
     */
    readonly version?: string
}

/**
 * Request parameters for employeeV2OpenshiftsInRangeGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeV2OpenshiftsInRangeGetRequest
 */
export interface EmployeeApiEmployeeV2OpenshiftsInRangeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeV2OpenshiftsInRangeGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeV2OpenshiftsInRangeGet
     */
    readonly endDate?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeV2OpenshiftsInRangeGet
     */
    readonly version?: string
}

/**
 * Request parameters for employeeV2WorkSchedulesGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeV2WorkSchedulesGetRequest
 */
export interface EmployeeApiEmployeeV2WorkSchedulesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeV2WorkSchedulesGet
     */
    readonly payDate?: string
}

/**
 * Request parameters for employeeV2WorkSchedulesInRangeGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeV2WorkSchedulesInRangeGetRequest
 */
export interface EmployeeApiEmployeeV2WorkSchedulesInRangeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeV2WorkSchedulesInRangeGet
     */
    readonly payDate?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeV2WorkSchedulesInRangeGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for employeeWorkSchedulesGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeWorkSchedulesGetRequest
 */
export interface EmployeeApiEmployeeWorkSchedulesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeWorkSchedulesGet
     */
    readonly payDate?: string
}

/**
 * Request parameters for employeeWorkSchedulesInRangeGet operation in EmployeeApi.
 * @export
 * @interface EmployeeApiEmployeeWorkSchedulesInRangeGetRequest
 */
export interface EmployeeApiEmployeeWorkSchedulesInRangeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeWorkSchedulesInRangeGet
     */
    readonly payDate?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeeApiEmployeeWorkSchedulesInRangeGet
     */
    readonly endDate?: string
}

/**
 * EmployeeApi - object-oriented interface
 * @export
 * @class EmployeeApi
 * @extends {BaseAPI}
 */
export class EmployeeApi extends BaseAPI {
    /**
     * 
     * @summary Get employee\'s accruals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeAccrualsGet(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeAccrualsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Menu Items Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeAppMenuGet(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeAppMenuGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change Password  To allow users to update their password, we will need to create an endpoint on your server that accepts the user\'s current password and the new password, and then updates the password in your database.
     * @param {EmployeeApiEmployeeChangePasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeChangePasswordPost(requestParameters: EmployeeApiEmployeeChangePasswordPostRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeChangePasswordPost(requestParameters.changePasswordRequestModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeConfigurationGet(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeConfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeDeleteAccountDelete(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeDeleteAccountDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns scheduler-pro work patterns when the work pattern is enabled for scheduler AND the  facility uses the scheduler website, otherwise the simple-scheduling patterns. SPD-5493: the  caller passes enabledForScheduler reflecting the Work Pattern modal\'s  \'Enabled for Scheduler\' checkbox; when omitted it falls back to the employee\'s saved state.
     * @param {EmployeeApiEmployeeEmployeeIdWorkPatternOptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeEmployeeIdWorkPatternOptionsGet(requestParameters: EmployeeApiEmployeeEmployeeIdWorkPatternOptionsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeEmployeeIdWorkPatternOptionsGet(requestParameters.employeeId, requestParameters.enabledForScheduler, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a list of employees, either all or filtered by a search term.
     * @param {EmployeeApiEmployeeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeGet(requestParameters: EmployeeApiEmployeeGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeGet(requestParameters.searchText, requestParameters.numberOfEmployeePerPage, requestParameters.page, requestParameters.employeeStatusTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeIdAbsenceRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeIdAbsenceRequestsGet(requestParameters: EmployeeApiEmployeeIdAbsenceRequestsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeIdAbsenceRequestsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs from mobile
     * @param {EmployeeApiEmployeeLogPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeLogPost(requestParameters: EmployeeApiEmployeeLogPostRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeLogPost(requestParameters.logRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeLogoutGet(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeLogoutGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeLogoutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeLogoutPost(requestParameters: EmployeeApiEmployeeLogoutPostRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeLogoutPost(requestParameters.loggOutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs from mobile
     * @param {EmployeeApiEmployeeLogsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeLogsPost(requestParameters: EmployeeApiEmployeeLogsPostRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeLogsPost(requestParameters.logsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeOpenshiftGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeOpenshiftGet(requestParameters: EmployeeApiEmployeeOpenshiftGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeOpenshiftGet(requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeOpenshiftOpenShiftIdInterestedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeOpenshiftOpenShiftIdInterestedPost(requestParameters: EmployeeApiEmployeeOpenshiftOpenShiftIdInterestedPostRequest, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeOpenshiftOpenShiftIdInterestedPost(requestParameters.openShiftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeOpenshiftsInRangeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeOpenshiftsInRangeGet(requestParameters: EmployeeApiEmployeeOpenshiftsInRangeGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeOpenshiftsInRangeGet(requestParameters.startDate, requestParameters.endDate, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The returned OpenShifts.BusinessObjects.Response.PayPeriodDayOfWeekResponse contains `DayIndex` (0–6),  where 0 = Sunday and 6 = Saturday.
     * @summary Retrieves the start day of the week for the current employee\'s pay period.
     * @param {EmployeeApiEmployeePayperiodStartDayofweekGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeePayperiodStartDayofweekGet(requestParameters: EmployeeApiEmployeePayperiodStartDayofweekGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeePayperiodStartDayofweekGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeePayperiodsGet(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeePayperiodsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeePaytypeStartDateEndDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeePaytypeStartDateEndDateGet(requestParameters: EmployeeApiEmployeePaytypeStartDateEndDateGetRequest, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeePaytypeStartDateEndDateGet(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permissions api will allow the mobile to directly access database configuration items  and hide and show mobile items based on the configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeePermissionsGet(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeePermissionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a filtered and paginated list of employees.
     * @param {EmployeeApiEmployeePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeePost(requestParameters: EmployeeApiEmployeePostRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeePost(requestParameters.findEmployeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeePunchHistoryWithSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeePunchHistoryWithSummaryGet(requestParameters: EmployeeApiEmployeePunchHistoryWithSummaryGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeePunchHistoryWithSummaryGet(requestParameters.payPeriodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeRemoveShiftPost(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeRemoveShiftPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeResetPasswordPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeResetPasswordPut(requestParameters: EmployeeApiEmployeeResetPasswordPutRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeResetPasswordPut(requestParameters.lockUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeShiftSummaryGet(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeShiftSummaryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeShifttypesGet(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeShifttypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeTimecardGet(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeTimecardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeV2OpenshiftGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeV2OpenshiftGet(requestParameters: EmployeeApiEmployeeV2OpenshiftGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeV2OpenshiftGet(requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeV2OpenshiftsInRangeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeV2OpenshiftsInRangeGet(requestParameters: EmployeeApiEmployeeV2OpenshiftsInRangeGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeV2OpenshiftsInRangeGet(requestParameters.startDate, requestParameters.endDate, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeV2WorkSchedulesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeV2WorkSchedulesGet(requestParameters: EmployeeApiEmployeeV2WorkSchedulesGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeV2WorkSchedulesGet(requestParameters.payDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeV2WorkSchedulesInRangeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeV2WorkSchedulesInRangeGet(requestParameters: EmployeeApiEmployeeV2WorkSchedulesInRangeGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeV2WorkSchedulesInRangeGet(requestParameters.payDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeWorkSchedulesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeWorkSchedulesGet(requestParameters: EmployeeApiEmployeeWorkSchedulesGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeWorkSchedulesGet(requestParameters.payDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeApiEmployeeWorkSchedulesInRangeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public employeeWorkSchedulesInRangeGet(requestParameters: EmployeeApiEmployeeWorkSchedulesInRangeGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).employeeWorkSchedulesInRangeGet(requestParameters.payDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}
